import Icon from '@/assets/icons/movie.svg';
import { ClientAuth, Device, Logger } from '@/classes';
import { useRouter } from '@/hooks/useRouter';
import { Menu } from '@/widgets/menu';
import { MovieContentGroupList } from '@/widgets/movie-content-list';
import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const MoviesPage = () => {
  const router = useRouter();
  const { t } = useTranslation();

  const header = useMemo(
    () => (
      <>
        <img src={Icon} />
        <h1 className={`ml-3 text-[55px] text-white ${Device.language !== 'zh' && 'font-bold'}`}>
          {t('menu_cinema_and_tv')}
        </h1>
      </>
    ),
    [t],
  );

  useEffect(() => {
    if (!ClientAuth.user) {
      router.push('/login', { replace: true });
    }
  }, [router]);

  useEffect(() => {
    Logger.homeMovies();
  }, []);

  return (
    <div className="flex flex-col lg:flex-row h-screen">
      <Menu />
      <div className="flex flex-1 overflow-hidden">
        <MovieContentGroupList
          sourcePage="movie"
          containerClassName="w-full h-screen overflow-x-hidden overflow-y-auto bg-black"
          headerClassName="pl-[52px] py-[16px] fixed flex items-center font-babyshark z-40 w-full bg-black"
          header={header}
        />
      </div>
    </div>
  );
};
